<template>
  <div>
    <div class="content-bottom-padded">
      <el-alert
              type="info"
              show-icon>
        <div>
          每天凌晨拉取对账单，
          目前只支持浦发银卡小浦支付对账单下载，其他交易对账单下载暂不支持。
          导出格式化显示对账单
        </div>
      </el-alert>
    </div>
    <el-row :gutter="20">
      <el-col :span="4">
        <el-select v-model="third_name_value" placeholder="请选择" @change="thirdNameChange">
        <el-option
                v-for="item in third_name"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
        </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-date-picker v-model="create_time" type="daterange" placeholder="选择日期范围" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
      </el-col>

      <el-col :md="4" :lg="4">
          <el-button size="mini" type="primary" @click="exportData">导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
      </el-col>
    </el-row>
    <el-row :gutter="20">
    </el-row>
    <el-dialog title="对账单下载" :visible.sync="downloadView" :close-on-click-modal="false">
      <template v-if="downloadUrl">
        <a :href="downloadUrl" download>{{downloadName}}</a>
      </template>
    </el-dialog>
    <el-tabs type="border-card"  >
      <template>
        <el-table :data="list" style="width: 100%">
          <el-table-column prop="type_name" label="支付方式" width="180">
            <template slot-scope="scope">
            <span v-if="scope.row.type_name == 'wxpay'">微信支付</span>
            <span v-if="scope.row.type_name == 'wxpayapp'">微信APP支付</span>
            <span v-if="scope.row.type_name == 'alipayapp'">支付宝APP支付</span>
            <span v-if="scope.row.type_name == 'alipay'">支付宝支付</span>
            <span v-if="scope.row.type_name == 'deposit'">余额支付</span>
            <span v-if="scope.row.type_name == 'pos'">POS银行卡支付</span>
            <span v-if="scope.row.type_name == 'spdb_h5_xppay'">浦发小浦支付</span>
            <span v-if="scope.row.type_name == 'ccb_h5_digital'">建行数字货币支付</span>
            <span v-if="scope.row.type_name == 'jh_digital'">交行数字货币支付</span>
            <span v-if="scope.row.type_name == 'fuioupay_miniprogram'">富友微信小程序支付</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="下载日期" width="180">
            <template slot-scope="scope">
            <span>{{scope.row.datetime | datetime('yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="对账内容">
          </el-table-column>
        </el-table>
      </template>

      <div class="content-center content-padded">
        <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="params.page"
                :page-sizes="[10,20,50]"
                :total="total_count"
                :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
  </div>
</template>
<script>

  import { getStatementlist, statementExport } from '../../../api/trade'

  export default {
    data () {
      return {
        loading: false,
        total_count: 0,
        status: '',
        create_time: '',
        date_begin: '',
        date_end: '',
        params: {
          page: 1,
          pageSize: 20
        },
        list: [],
        downloadView: false,
        downloadUrl: '',
        downloadName: '',
        third_name: [{
              value: 'spdb_h5_xppay',
              label: '浦发小浦支付',
          }, {
              value: 'ccb_h5_digital',
              label: '建行数字货币支付',
              disabled:true,
          },{
            value: 'jh_digital',
            label: '交行数字货币支付',
            disabled:true,
          },
        ],
          third_name_value:'',
      }
    },
    methods: {
      // 切换tab

      dateChange (val) {
        if (val.length > 0) {
          this.date_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.date_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.date_begin = ''
          this.date_end = ''
        }
        this.params.page = 1
        this.getParams()
        this.getList(this.params)
      },
      handleCurrentChange (val) {
        this.params.page = val
        this.getParams()
        this.getList(this.params)
      },
      handleSizeChange (pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getParams()
        this.getList(this.params)
      },
      thirdNameChange(val){
          this.third_name_value =  val
          this.getParams()
          this.getList(this.params)
      },
      getParams () {
        this.params.time_start_begin = this.date_begin
        this.params.time_start_end = this.date_end
        this.params.type_name = this.third_name_value
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
      getList(filter) {
        this.loading = true
          getStatementlist(filter).then(response => {
          this.list = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
      },
      exportData() {
        this.getParams()
        this.params.page = 1
          statementExport(this.params).then(response => {
          if (response.data.status) {
              this.$message({
                  type: 'success',
                  message: '已加入执行队列，请在设置-导出列表中下载'
              })
              return
          } else if (response.data.url) {
              this.downloadUrl = response.data.url
              this.downloadName = response.data.filename
              this.downloadView = true
          } else {
            this.$message({
                type: 'error',
                message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// statementlist.vue?91c04da0